import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vee-validate';
import './plugins/filters';

import App from './App.vue';
import router from './router';
import store from './store';
import 'roboto-fontface/css/roboto/roboto-fontface.css';

import Axios from 'axios';
import VueI18n from 'vue-i18n';
import en from './languages/en/en_US';
import es from './languages/es/es_ES';

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
Vue.use(VueI18n);

const messages = {
  en: en,
  es: es,
};

const moment = require('moment');
require('moment/locale/es');

Vue.use(require('vue-moment'), {
  moment,
});

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'es', // set locale
  messages, // set locale messages
  silentTranslationWarn: true,
});

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

new Vue({
  i18n,
  router,
  store,
  filters: {
    moment: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
  },
  render: h => h(App),
}).$mount('#app');
